import styled from "styled-components";
import { 
  Form as AntForm,
  Typography as AntTypography 
} from "antd";
import { BackArrow } from '@assets';
import lightTheme from '@styles/theme';
import { AuthBg, AuthLogo } from "@assets/auth";

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-image: url(${AuthBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  padding: 0px 16px;
`;

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 16px;
`;

export const ArrowIconWrapper = styled.div`
  width: 37px;
  height: 37px;
  background-color: ${lightTheme.appbarColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  cursor: pointer;
`

export const BackIcon = styled(BackArrow)`
  width: 25px;
  height: 25px;
`;

export const Logo = styled(AuthLogo)`
  margin: 36px 0 0 0;
`

export const ContentContainer = styled.div`
  width: 100%;
  margin: 39px auto 24px;
`

export const Title = styled(AntTypography.Title)`
  color: #FFC654 !important;
  text-align: center;
  font-size: 20px !important;
  padding-left: 24px;
  font-style: normal;
  font-weight: 500 !important;
  line-height: normal !important;
` 

export const Form = styled(AntForm)`
  margin-top: 30px;
  width: 100%;
  text-align: center;

  .ant-form-item {
    margin-bottom: 24px;
  }

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 8px;
  }

  .ant-form-item-label {
    margin: 0px 0 2px 8px;
    margin-left: 8px;
    text-align: left;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    color: #DADADA;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .ant-input-affix-wrapper {
    height: 56px;
    border-radius: 10px;
  }

  .ant-btn-primary {
    width: 100%;
    height: 56px;
  }
`;

